import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';

@Pipe({ name: 'numeral' })
export class NumeralPipe implements PipeTransform {
    transform(
        value: number | undefined,
        format: string,
        suffix: string = '',
        bypassUndefined: boolean = false
    ): string | undefined {
        if (value === undefined) {
            return bypassUndefined ? undefined : '0';
        }
        return `${numeral(value).format(format)}${suffix}`;
    }
}
